module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-regular-78a4b5344e4298da859cf1a5f5b0b06c.svg";